import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { media } from '@belong/themes';
import { PictureContainer } from '@belong/ui-components';

const imageWidths = {
  large: '23rem',
  'large.md': '31rem',
  small: '15rem',
  icon: '7.2rem'
};

export const Image = styled(PictureContainer)<{ size }>`
  display: block;
  width: ${(props): string => imageWidths[props.size]};
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;

  ${breakpoint('md')`
    width: ${(props): string => imageWidths[`${props.size}.md`] || imageWidths[props.size]};  
  `}
`;

// control reference component styling
export const ReferenceWrapper = styled.div`
  margin: 2.4rem 0;

  ${media('md')`
    margin-top: 1.6rem;
  `}
`;
